import { Grid } from "@mui/material";
import React from "react";
import PosTypeHeader from "./home/header";
import PosFieldTable from "./home/table";

const PosType = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PosTypeHeader />
      </Grid>
      <Grid item xs={12}>
        <PosFieldTable />
      </Grid>
    </Grid>
  );
};

export default PosType;
